export default function buildBackgroundUrl(system) {
    return `url(/img/bg/bg_${system.toLowerCase()}.jpg)`
}
